import { EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  production: false,
  backend_url: 'https://api.cocadev.alzp.tgscloud.net',
  agGridLicenseKey: '',
  authentication: {
    clientId: 'c3ded810-88b5-402b-9279-b56d9cc9d9db',
    authority:
      'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e',
    scopes: ['api://38c0bc87-0060-4ee2-ab5c-33199fcf4f99/all'],
    redirectUri: '/home',
  },
  awsrum: {
    enabled: true,
    region: 'eu-central-1',
    guestRoleArn: 'arn:aws:iam::468015346332:role/RUM_write_unauthenticated',
    identityPoolId: 'eu-central-1:9dcf72c7-624f-43d6-a3cf-2ed903c43026',
    applicationId: '7af23adb-b1fe-412d-8f86-c848a3d00596',
  },
};
